import ImagePlaceHolder from "@/components/Placeholder/ImagePlaceHolder";

export default function CustomImageLoader({
  children,
  width,
  height,
  isLoading,
}: CustomImageLoaderProps) {
  return (
    <>
      {isLoading ? (
        <ImagePlaceHolder width={width} height={height} />
      ) : (
        children
      )}
    </>
  );
}

interface CustomImageLoaderProps {
  children: React.ReactElement;
  width: number | string | undefined;
  height: number | string | undefined;
  isLoading: boolean;
}
